import React from 'react';
import styled from '@emotion/styled';

interface PropsType {
    className?: string;
}

const SvgElement = styled('svg', { label: 'SvgElement' })<PropsType>`
    height: auto;
`;

export const Logo18Plus = ({ className }: PropsType): JSX.Element => (
    <SvgElement
        className={className}
        xmlns='http://www.w3.org/2000/svg'
        width={28}
        height={28}
        fill='none'
        viewBox='0 0 28 28'
    >
        <path
            fill='#E83737'
            fillRule='evenodd'
            d='M0 14c0 7.732 6.268 14 14 14s14-6.268 14-14S21.732 0 14 0 0 6.268 0 14Z'
            clipRule='evenodd'
        />
        <path
            fill='#fff'
            d='M8.486 9.796H5.11v1.417h1.766v6.991h1.61V9.796Z'
        />
        <path
            fill='#fff'
            fillRule='evenodd'
            d='M16.305 11.934c0-.68-.254-1.22-.762-1.616-.509-.396-1.204-.594-2.084-.594-.865 0-1.552.194-2.06.582-.509.389-.763.911-.763 1.568 0 .392.11.749.33 1.069.22.32.527.577.919.769-.52.184-.929.466-1.225.847a2.08 2.08 0 0 0-.445 1.315c0 .488.133.913.397 1.273.264.36.642.639 1.135.835.492.196 1.067.294 1.724.294.656 0 1.23-.098 1.723-.294.493-.196.871-.479 1.135-.847.265-.368.397-.797.397-1.285 0-.489-.142-.921-.427-1.297-.284-.377-.674-.657-1.17-.841.368-.176.656-.42.864-.733.208-.312.312-.66.312-1.045Zm-4.312.084c0-.36.13-.64.39-.84.26-.201.623-.301 1.088-.301.464 0 .824.1 1.08.3.257.2.385.48.385.841 0 .36-.128.64-.384.84-.257.201-.617.301-1.081.301-.465 0-.827-.1-1.088-.3-.26-.2-.39-.48-.39-.841Zm-.264 3.676c0-.409.152-.725.456-.95.305-.223.729-.336 1.274-.336.552 0 .983.115 1.29.343.31.228.463.546.463.955 0 .416-.154.738-.462.967-.308.228-.735.342-1.28.342-.552 0-.98-.116-1.285-.348-.304-.233-.456-.557-.456-.973Z'
            clipRule='evenodd'
        />
        <path
            fill='#fff'
            d='M22.888 14.84v-1.08h-2.09v-2.078h-1.021v2.078h-2.078v1.08h2.078v2.067h1.02V14.84h2.091Z'
        />
    </SvgElement>
);
